import React from 'react';

interface ErrorHandlerProps {
  error: any;
  onRetry?: () => void;
  title?: string;
}

const ErrorHandler: React.FC<ErrorHandlerProps> = ({ error, onRetry, title = 'Error' }) => {
  const getErrorMessage = (error: any): string => {
    if (error.response?.status === 401) {
      return 'Authentication failed. Please check your API key configuration.';
    } else if (error.response?.status === 403) {
      return 'Access forbidden. You do not have permission to access this resource.';
    } else if (error.response?.status >= 500) {
      return 'Server error. Please try again later.';
    } else if (error.code === 'NETWORK_ERROR' || !error.response) {
      return 'Network error. Please check your internet connection.';
    }
    return error.message || 'An unexpected error occurred.';
  };

  const getErrorIcon = (error: any): string => {
    if (error.response?.status === 401) return '🔑';
    if (error.response?.status === 403) return '🚫';
    if (error.response?.status >= 500) return '⚠️';
    if (error.code === 'NETWORK_ERROR' || !error.response) return '🌐';
    return '❌';
  };

  return (
    <div className="error-handler">
      <div className="error-message">
        <div className="error-icon">{getErrorIcon(error)}</div>
        <h3>{title}</h3>
        <p className="error-text">{getErrorMessage(error)}</p>
        {error.response?.status && (
          <p className="error-status">Status: {error.response.status}</p>
        )}
        {onRetry && (
          <button onClick={onRetry} className="retry-button">
            🔄 Retry
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorHandler;
